define([
    'handlebars',
    'moment-wrapper',
    'appcontext'
], (
    Handlebars,
    moment,
    appContext
) => {
    var mdash = new Handlebars.SafeString('&mdash;');

    /**
     * Debug helper to console.log context from template
     * USE FOR DEBUG ONLY
     */
    Handlebars.registerHelper('debug', function (optionalValue) {
        console.log('..:Current Context:..');
        console.log(this);
        console.log('=====================');

        if (optionalValue) {
            console.log('......::Value::......');
            console.log(optionalValue);
            console.log('=====================');
        }
    });

    Handlebars.registerHelper('breaklines', (text) => {
        text = Handlebars.Utils.escapeExpression(text);
        text = text.replace(/(\r\n|\n|\r)/gm, '<br>');
        return new Handlebars.SafeString(text);
    });

    Handlebars.registerHelper('h_div', (a, b, options) => {
        var coef = options.hash.percent ? 100 : 1;
        var scale = options.hash.scale;
        return Number(b) ? Number(a) / Number(b) * coef * (scale || 1) : null;
    });

    Handlebars.registerHelper('h_currency_symbol', (options) => {
        var currency_id = options.hash.currency_id;
        var currencies = appContext.currencies();
        var currency = !_.isUndefined(currency_id) ? currencies.get(currency_id) : appContext.accountCurrency();
        return currency ? currency.get('symbol') : mdash;
    });

    Handlebars.registerHelper('h_date', (date, options) => {
        var grouping = options.hash.grouping;
        var helpers = Handlebars.helpers;
        return _.isUndefined(grouping) ? helpers.h_date_plain(date, options) : helpers.h_date_grouped(date, grouping);
    });

    Handlebars.registerHelper('h_date_plain', (date) => date ? moment(date).
        formatDate() : mdash);

    Handlebars.registerHelper('h_date_grouped_weeks', (date) => {
        if (date) {
            var start = moment(date);
            var end = start.clone().
                add('days', 6);

            return '{0} ‒ {1} ({2})'.format(start.formatDate(), end.formatDate(), start.week());
        }
        return mdash;

    });

    Handlebars.registerHelper('h_date_grouped', (date, grouping) => {
        var str; var outputFormat;
        switch (grouping) {
        case 'day':
            str = Handlebars.helpers.h_date_plain(date);
            break;
        case 'week':
            str = Handlebars.helpers.h_date_grouped_weeks(date);
            break;
        case 'month':
            outputFormat = 'formatGroupedMonths';
            break;
        case 'quarter':
            outputFormat = 'formatGroupedQuarters';
            break;
        case 'year':
            outputFormat = 'formatGroupedYears';
            break;
        default:
            break;
        }

        if (_.isUndefined(outputFormat) && _.isUndefined(str)) {
            str = mdash;
        } else if (_.isUndefined(str)) {
            str = moment(date)[outputFormat]();
        }

        return str;
    });

    Handlebars.registerHelper('h_date_empty', (date) => date ? moment(date).
        formatDate() : '');

    Handlebars.registerHelper('h_datetime_empty', (dateTime) => dateTime ? moment(dateTime).
        formatDatetime() : '');

    Handlebars.registerHelper('h_day', (date) => date ? moment(date).
        date() : mdash);

    Handlebars.registerHelper('h_datetime', (date, options) => {
        if (!date) {
            return mdash;
        }

        var result;
        var date = moment(date);

        if (options.hash.tinyTime) {
            result = '{0}&nbsp;<span style="color: #909090; font-size: 10px;">{1}</span>'.format(
                date.formatDate(options.hash), date.formatTime(options.hash)
            );
        } else if (options.hash.noSeconds) {
            result = '{0}&nbsp;{1}'.format(date.formatDate(options.hash), date.formatTime(options.hash));
        } else {
            result = date.formatDatetime();
            options.hash.nbsp ? result = result.split(' ').
                join('&nbsp;') : {};
        }

        return new Handlebars.SafeString(result);
    });

    Handlebars.registerHelper('h_time', (date, options) => {
        var result = date ? moment(date).
            formatTime(options.hash) : mdash;
        options.hash.nbsp ? result = new Handlebars.SafeString(result.split(' ').
            join('&nbsp;')) : {};
        return result;
    });

    Handlebars.registerHelper('h_days', (start_date, end_date) => end_date && start_date ? moment(end_date).
        diff(moment(start_date), 'days') + 1 : mdash);

    /**
     * Params which leading with underscore are passed into appContext as
     * 3rd param with stripping the leading underscore
     */
    Handlebars.registerHelper('h_url', (url, options) => {
        var opt = {}; var params = {};
        for (var key in options.hash) {
            if (key.lastIndexOf('_', 0) === 0) {
                opt[key.substring(1)] = options.hash[key];
            } else {
                params[key] = options.hash[key];
            }
        }
        return appContext.url(url, params, opt);
    });

    Handlebars.registerHelper('h_active', (tab, thisTab) => tab === thisTab ? 'active' : '');

    Handlebars.registerHelper('h_active_unless', (tab, thisTab) => tab !== thisTab ? 'active' : '');

    Handlebars.registerHelper('h_pretty_lowercase', (value) => value.toLowerCase().
        replace(/\_/g, ' '));

    Handlebars.registerHelper('linkp', function (url, permission, options) {
        var text = options.fn(this);
        if (!appContext.can_user(permission)) {
            return text;
        }

        var attrs = _.extend({href: url}, options.hash);
        return new Handlebars.SafeString($('<div>').
            append($('<a>').
                attr(attrs).
                html(text)).
            html());
    });

    Handlebars.registerHelper('linkp_ac', function (url, permission, options) {
        var text = options.fn(this);
        if (Boolean(appContext.accountId()) && !appContext.can_user(permission)) {
            return text;
        }

        var attrs = _.extend({href: url}, options.hash);
        return new Handlebars.SafeString($('<div>').
            append($('<a>').
                attr(attrs).
                html(text)).
            html());
    });

    Handlebars.registerHelper('if_can', function () {
        var options = [].pop.call(arguments);
        var permissions = _.map(arguments, (arg) => arg);
        permissions = permissions.length === 1 ? permissions[0] : permissions;
        if (appContext.can_user(permissions)) {
            return options.fn(this);
        }
        return options.inverse(this);

    });

    Handlebars.registerHelper('if_can_any', function () {
        var options = [].pop.call(arguments);
        for (var i = 0; i < arguments.length; i++) {
            if (appContext.can_user(arguments[i])) {
                return options.fn(this);
            }
        }
        return options.inverse(this);
    });

    Handlebars.registerHelper('if_has_component', function () {
        var options = [].pop.call(arguments);
        var components = _.map(arguments, (arg) => arg);
        if (appContext.has_component(components)) {
            return options.fn(this);
        }
        return options.inverse(this);

    });

    Handlebars.registerHelper('if_has_not_component', function () {
        var options = [].pop.call(arguments);
        var components = _.map(arguments, (arg) => arg);
        if (appContext.has_component(components)) {
            return options.inverse(this);
        }
        return options.fn(this);

    });

    Handlebars.registerHelper('if_admin', function (options) {
        return appContext.user().
            isAdmin() ? options.fn(this) : options.inverse(this);
    });

    Handlebars.registerHelper('if_not_admin', function (options) {
        return appContext.user().
            isAdmin() ? options.inverse(this) : options.fn(this);
    });

    Handlebars.registerHelper('if_can_not', function (permission, options) {
        if (appContext.can_user(permission)) {
            return options.inverse(this);
        }
        return options.fn(this);

    });

    Handlebars.registerHelper('if_defined', function (value, options) {
        return !_.isUndefined(value) ? options.fn(this) : options.inverse(this);
    });

    Handlebars.registerHelper('unless_defined', function (value, options) {
        return _.isUndefined(value) ? options.fn(this) : options.inverse(this);
    });

    Handlebars.registerHelper('h_img', (src, options) => {
        var attrs = {src};
        if (options && options.hash) {
            _.extend(attrs, options.hash);
        }
        return new Handlebars.SafeString($('<div>').
            append($('<img>').
                attr(attrs)).
            html());
    });

    Handlebars.registerHelper('h_channel_img', (channel_id, options) => {
        var channel = appContext.channels().
            get(channel_id);
        options = options || {};
        options.hash = options.hash || {};

        const ozonIcon = require('assets/channels/ozon.svg').default;
        const iconsMap = {
            adform: require('assets/channels/adform.svg').default,
            adfox: require('assets/channels/adfox.svg').default,
            adriver: require('assets/channels/adriver.svg').default,
            begun: require('assets/channels/begun.svg').default,
            custom: require('assets/channels/custom.svg').default,
            facebook: require('assets/channels/facebook.svg').default,
            google: require('assets/channels/google.svg').default,
            googledbm: require('assets/channels/googledbm.svg').default,
            googledcm: require('assets/channels/googledcm.svg').default,
            ozon: ozonIcon,
            ozonseller: ozonIcon,
            rbmail: require('assets/channels/rbmail.svg').default,
            targetmail: require('assets/channels/targetmail.svg').default,
            twitter: require('assets/channels/twitter.svg').default,
            tiktok: require('assets/channels/tiktok.svg').default,
            vkontakte: require('assets/channels/vkontakte.svg').default,
            weborama: require('assets/channels/weborama.svg').default,
            yandex: require('assets/channels/yandex.svg').default,
            yandexaudience: require('assets/channels/yandexaudience.svg').default,
            yandexdisplay: require('assets/channels/yandexdisplay.svg').default,
            yandexmarket: require('assets/channels/yandexmarket.svg').default,
            youtube: require('assets/channels/youtube.svg').default,
            wildberries: require('assets/channels/wildberries.svg').default,
            vkads: require('assets/channels/vkads.svg').default
        };

        if (channel) {
            _.defaults(options.hash, {
                alt: channel.get('display_name'),
                style: 'max-width: none; width: 16px; height: 16px;'
            });
            return Handlebars.helpers.h_img(iconsMap[channel.get('name')], options);
        }
        return new Handlebars.SafeString('&mdash;');

    });

    Handlebars.registerHelper('h_wa_img', (provider_id, options) => {
        var provider = appContext.waProviders().
            get(provider_id);
        options = options || {};
        options.hash = options.hash || {};

        const waIconsMap = {
            amocrm: require('assets/webanalyticsproviders/amocrm.svg').default,
            appmetrica: require('assets/webanalyticsproviders/appmetrica.svg').default,
            comagic: require('assets/webanalyticsproviders/comagic.svg').default,
            custom: require('assets/webanalyticsproviders/custom.svg').default,
            yandexmetrika: require('assets/webanalyticsproviders/yandexmetrika.svg').default,
            googleanalytics: require('assets/webanalyticsproviders/googleanalytics.svg').default
        };

        if (provider) {
            options.hash = {
                alt: provider.get('display_name'),
                style: 'max-width: none; width: 16px; height: 16px;'
            };
            return Handlebars.helpers.h_img(waIconsMap[provider.get('name')], options);
        }
        return new Handlebars.SafeString('&mdash;');

    });

    Handlebars.registerHelper('h_channel_name', (channel_id) => {
        var channel = appContext.channels().
            get(channel_id);
        return channel ? channel.get('display_name') : new Handlebars.SafeString('&mdash;');
    });

    Handlebars.registerHelper('h_icon', (value, options) => {
        var attrs;
        var yes = appContext.tr('yes'); var no = appContext.tr('no'); var unknown = appContext.tr('unknown');
        var path = appContext.baseImageUrl();
        if (value) {
            attrs = {
                src: `${path}icon-yes.gif`,
                alt: yes,
                title: yes
            };
        } else if (value === false || !options.hash.tristate) {
            attrs = {
                src: `${path}icon-no.gif`,
                alt: no,
                title: no
            };
        } else {
            attrs = {
                src: `${path}icon-unknown.gif`,
                alt: unknown,
                title: unknown
            };
        }
        return new Handlebars.SafeString($('<div>').
            append($('<img>').
                attr(attrs)).
            html());
    });

    Handlebars.registerHelper('h_comma', (arr) => arr.join(', '));

    Handlebars.registerHelper('h_join', (str, arr) => arr.join(str));

    Handlebars.registerHelper('_', (text, options) => appContext.tr(text).
        format(options.hash));

    Handlebars.registerHelper('ngettext', (singular, plural, n, options) => appContext.ngettext(singular, plural, n).
        format(options.hash));

    Handlebars.registerHelper('pgettext', (context, text) => appContext.trc(context, text));

    Handlebars.registerHelper('if_op', function (x, op, y, options) {
        var cond;
        switch (op) {
        case '&&':
            cond = x && y;
            break;

        case '||':
            cond = x || y;
            break;

        default:
            cond = undefined;
            break;
        }

        if (cond) {
            return options.fn(this);
        }
        return options.inverse(this);

    });

    Handlebars.registerHelper('h_account_state', (state) => {
        var states = {
            A: appContext.tr('Active'),
            B: appContext.tr('Blocked'),
            D: appContext.tr('Deleted'),
            W: appContext.tr('Invitation sent')
        };
        if (state in states) {
            return states[state];
        }
        return mdash;
    });

    Handlebars.registerHelper('h_check', (value) => {
        if (value) {
            return new Handlebars.SafeString('<i class="icon-ok"></i>');
        }
        return '';
    });

    Handlebars.registerHelper('h_sort_field', (sorting, field, options) => {
        if (_.isUndefined(sorting)) {
            return '';
        }

        var item = _.find(sorting, (item) => item.name === field);
        var order = item ? item.direction > 0 ? 'asc' : 'desc' : undefined;
        var cls = options.hash._class || '';
        var str;

        if (_.isUndefined(order)) {
            str = ' class="sortable {0}" data-sort-name="{1}" data-sort-default="desc" '.format(cls, field);
        } else {
            str = ' class="sortable sort-{0} {1}" data-sort-name="{2}" '.format(order, cls, field);
        }

        return new Handlebars.SafeString(str);
    });

    Handlebars.registerHelper('h_json', (value) => JSON.stringify(value));

    Handlebars.registerHelper('h_help', (context, text, options) => {
        var attrs;
        var img = $('<i>').
            addClass('icon-question-sign help-icon');
        var content = appContext.helpFor(context, text);

        if (content === text && !appContext.showEmptyHelp()) {
            return '';
        }

        attrs = {
            'data-toggle': 'popover',
            'data-content': content,
            'data-placement': options.hash.placement || 'right'
        };
        return new Handlebars.SafeString($('<div>').
            append($('<a>').
                addClass('help').
                attr(attrs).
                append('&nbsp;').
                append(img)).
            html());
    });

    Handlebars.registerHelper('h_value_or_mdash', (value) => _.isNull(value) ? mdash : value);

    Handlebars.registerHelper('if_contains', function (context, options) {
        if (_.contains(options.hash.array, context)) {
            return options.fn(this);
        }
        return options.inverse(this);
    });
});
